document.addEventListener('DOMContentLoaded', () => {
  const collectionLists = document.querySelectorAll('[data-collection-list-section]');

  if (!collectionLists.length) return;

  collectionLists.forEach(collectionList => {
    const buttons = collectionList.querySelectorAll('[data-collection-list-filter]');
    const items = collectionList.querySelectorAll('[data-collection-list-item]');

    if (!buttons.length || !items.length) return;

    const setActiveFilter = activeHandle => {
      buttons.forEach(button => {
        const isActive = button.dataset.collectionListFilter === activeHandle;

        button.classList.toggle('button--FullSecondary', isActive);
        button.classList.toggle('button--FullTertiary', !isActive);
        button.setAttribute('aria-pressed', isActive.toString());
      });

      items.forEach(item => {
        const isVisible = !activeHandle || item.dataset.collectionListItem === activeHandle;

        item.hidden = !isVisible;
      });
    };

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const targetHandle = button.dataset.collectionListFilter || '';
        const currentHandle = collectionList.dataset.activeCollectionListFilter || '';
        const nextHandle = currentHandle === targetHandle ? '' : targetHandle;

        collectionList.dataset.activeCollectionListFilter = nextHandle;
        setActiveFilter(nextHandle);
      });
    });

    setActiveFilter(collectionList.dataset.activeCollectionListFilter || '');
  });
});
